import React, { useEffect, useState, Suspense } from 'react';
import './App.css';
import { Route,BrowserRouter as Router, Switch } from 'react-router-dom';

import db from '../utils/indexedDB';
import cloudDB from '../utils/cloudDB.js';

import { useAuthService } from '../utils/auth';

const ReactLazyWithPreload = importStatement => {
    const Component = React.lazy(importStatement);
    Component.preload = importStatement;
    return Component;
}

const Home = ReactLazyWithPreload(() => import('../Views/Home'))
const Settings = ReactLazyWithPreload(() => import('../Views/Settings'));
const DataTransfer = ReactLazyWithPreload(() => import('../Views/DataTransfer'));
const Info = ReactLazyWithPreload(() => import('../Views/Info'));
const Read = ReactLazyWithPreload(() => import('../Views/Read'))
const Profile = ReactLazyWithPreload(() => import('../Views/Profile'));
const Notebook = ReactLazyWithPreload(() => import('../Views/Notebook'));



function useDownloadService() {
    const [isDownloadable, setIsDownloadable] = useState(false);
    const [deferredPromptEvent, setDeferredPromptEvent] = useState(null);


    const addToHomescreen = () => {
        deferredPromptEvent.prompt();
        deferredPromptEvent.userChoice
            .then(function(choiceResult) {
                if(choiceResult.outcome === 'accepted') {
                    setIsDownloadable(false);
                }
            })
    }


    useEffect(() => {
        // beforeinstall prompt
        window.addEventListener('beforeinstallprompt',  (e) => {
            // Prevent Chrome 67 and earlier from automatically showing the prompt
            e.preventDefault();
            // Stash the event so it can be triggered later.
            setDeferredPromptEvent(e);
            setIsDownloadable(true);
        });

    }, [])

    return [isDownloadable, addToHomescreen];
}

function useLocalBooks() {
    const [result, setResult] = useState([]);

    const resetBooksData = () => {
        db.initDB()
            .then(() => {
                return db.getAllData();
            })
            .then(data => {
                setResult(data);
            })
    }

    useEffect(resetBooksData, []);

    return [result, resetBooksData];
}


function useCloudBooks(user) {
    const [result, setResult] = useState([]);

    const resetBooksData = (usr=user) => {
        if(!usr){
            setResult([]);
            return;
        }

        cloudDB.getAllData(usr.uid)
            .then(data => {
                setResult(data);
            })
    }

    useEffect(resetBooksData, [user]);

    return [result, resetBooksData];
}

function App() {
    const [localBooks, resetLocalBooksData] = useLocalBooks();
    
    const [user, login, logout] = useAuthService();
    const [isDownloadable, addToHomescreen] = useDownloadService();
    
    
    const [cloudBooks, resetCloudBooksData] = useCloudBooks(user);

    return (
        <Router>
            <Switch>
                <Route exact path="/" render={(props) =>
                    <Suspense fallback={<div></div>}>
                        <Home
                            {...props}
                            books={[...localBooks, ...cloudBooks]}
                            setBooksData={() => {resetLocalBooksData(); resetCloudBooksData(user);}}
                            isDownloadable={isDownloadable}
                            addToHomescreen={addToHomescreen}
                            user={user}
                            login={login}
                            logout={logout}
                            Notebook={Notebook}
                        />
                    </Suspense>
                } />

                <Route exact path="/notebook/:slug" render={(props) =>
                    <Suspense fallback={<div></div>}>
                        <Notebook
                            {...props}
                            books={[...localBooks, ...cloudBooks]}
                            setBooksData={() => {resetLocalBooksData(); resetCloudBooksData(user);}}
                            user={user}
                            login={login}
                            logout={logout}
                        />
                    </Suspense>
                } />

                <Route exact path="/notebook/:slug/settings" render={(props) =>
                    <Suspense fallback={<div></div>}>
                        <Settings
                            {...props}
                            books={[...localBooks, ...cloudBooks]}
                            setBooksData={() => {resetLocalBooksData(); resetCloudBooksData(user);}}
                            resetCloudBooksData={resetCloudBooksData}
                            user={user}
                            login={login}
                        />
                    </Suspense>
                } />

                <Route exact path="/data-transfer" render={ props => 
                    <Suspense fallback={<div></div>}>
                        <DataTransfer
                            {...props}
                            localBooks={localBooks}
                        />
                    </Suspense>
                } />

                <Route exact path="/info" render={props => 
                    <Suspense fallback={<div></div>}>
                        <Info {...props} />
                    </Suspense>
                } />

                <Route exact path="/profile" render={ props =>
                    <Suspense fallback={<div></div>}>
                        <Profile 
                            {...props}
                            user={user}
                            login={login}
                            logout={logout}
                            books={[...localBooks, ...cloudBooks]}
                            setBooksData={() => {resetLocalBooksData(); resetCloudBooksData(user);}}
                        />
                    </Suspense>
                } />
                <Route path="/:username/:slug" render={props => 
                    <Suspense fallback={<div></div>}>
                        <Read {...props} />
                    </Suspense>
                } />
            </Switch>

        </Router>

    )
}

export default App;